import { useRouteMatch } from 'react-router-dom';

export const useIsCommentsFeed = () => {
  const isGlobalComments = !!useRouteMatch('/needlbox/comments');
  const isCommentsFeedTab = !!useRouteMatch('/:category/:source/comments');

  return {
    isGlobalComments,
    isCommentsFeedTab,
  };
};
